export default __webpack_public_path__ + "static/media/shareYourProjects.c85c826c.png";